import { render } from "./layouts-sidebar.vue?vue&type=template&id=09a07cc7"
import script from "./layouts-sidebar.vue?vue&type=script&lang=js"
export * from "./layouts-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__